export default function switchLocale(locale) {
  localStorage.setItem("machinat_lang", locale);
  window.location.reload();
}
